import { render, staticRenderFns } from "./PagesSustainabilityWidget.vue?vue&type=template&id=1734a053&"
import script from "./PagesSustainabilityWidget.vue?vue&type=script&lang=js&"
export * from "./PagesSustainabilityWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports